<template>
  <div>
    <PageTitle
      title="Expense Setting"
      :btnCreate="true"
      :createRoute="'/expensesetting/create'"
      :permission="'Expense Setting Create'"
    />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <TableFilters
            :filters="['status', 'search']"
            v-model="filter"
            :columns="columns"
            :msgs="'Name'"
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0">
              <v-data-table
                class="li-100 row-pointer"
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="expenses"
                hide-default-footer
                item-key="id"
                @click:row="$router.push(`expensesetting/${$event.id}`)"
              >
                <template v-slot:no-data> </template>
                <template v-slot:footer="{}">
                  <paginationComponent
                    @paginationOptions="setPaginationOptions"
                    url="settings/expense-settings"
                    :filter="filter"
                    @getPageNumber="setPagenumber"
                    ref="pagination"
                    @response="receiveExpenseSetting"
                  />
                </template>
                <!-- Action -->

                <template v-slot:item.action="{ item }">
                  <list-menu
                    feature="expensesetting"
                    :item="item"
                    :filterAction="true"
                    viewPermission="Expense Setting Show"
                    editPermission="Expense Setting Edit"
                    softDeletePermission="Expense Setting Soft Delete"
                    @refreshList="refreshData"
                  ></list-menu>
                </template>
                <template v-slot:item.shop.name="{ item }">
                  {{ item.shop ? item.shop.name : '---' }}
                </template>

                <template v-slot:item.warehouse.name="{ item }">
                  {{ item.warehouse ? item.warehouse.name : '---' }}
                </template>
                <template v-slot:item.date="{ item }">
                  {{ item.date | formatDate }}
                </template>

                <!-- Status -->
                <template v-slot:item.is_active="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2"
                    label
                    text-color="white"
                    :color="getStatusColor(item.is_active)"
                    dark
                    >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                  >
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from './../../shared/components/pagination.vue';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

import confirmation from './../../shared/components/confirmation';
export default {
  data: () => ({
    show: false,
    paginationOptions: {},
    expenses: [],
    columns: [
      {
        text: 'Shop',
        value: 'shop.name',
        show: true,
        disabled: false,
        width: '20%',
        align: 'left',
      },
      {
        text: 'Warehouse',
        value: 'warehouse.name',
        show: true,
        disabled: false,
        width: '20%',
        align: 'left',
      },
      {
        text: 'Category',
        value: 'category.name',
        show: true,
        disabled: false,
        width: '20%',
        align: 'left',
      },

      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        width: '20%',
        align: 'left',
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '10%',
        align: 'left',
      },
      {
        text: 'Repeat',
        value: 'repeat',
        show: true,
        disabled: false,
        width: '10%',
        align: 'left',
      },

      {
        text: 'Remark',
        value: 'remark',
        show: true,
        disabled: false,
        width: '20%',
        align: 'left',
      },

      {
        text: 'Status',
        value: 'is_active',
        show: true,
        disabled: false,
        width: '10%',
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        width: '10%',
        align: 'center',
      },
    ],
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    filter: {
      search: '',
      status: '',
    },
  }),

  props: {},

  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    TableFilters,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    receiveExpenseSetting(data) {
      this.expenses = data;
    },
    getExpense() {
      this.$store
        .dispatch('ExpenseSetting/GetExpenseSettings')
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.messages = err.data?.title;
        });
    },

    getStatusColor(status) {
      return status == true ? 'green' : 'gray';
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show);
    },
  },
  created() {
    this.getExpense();
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.li-100 {
  font-family: 'Source Sans Pro', sans-serif;
  /* font-weight: bold; */
}
.min-button::before {
  display: none;
}
</style>
